import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_DASHBOARD_THERAPY_FAILURE,
  GET_DASHBOARD_THERAPY_LOADER,
  GET_DASHBOARD_THERAPY_SUCCESS,
  GET_DASHBOARD_THERAPY_REQUEST,
} = DashboardConstants;

function* dashboardTherapyOverview(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_THERAPY_LOADER });
    const response = yield call(dashboardServices.getDashboardTherapyOverView, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_THERAPY_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_THERAPY_FAILURE, payload: error });
  }
}

function* dashboardTherapyOverviewSaga() {
  yield takeEvery(GET_DASHBOARD_THERAPY_REQUEST, dashboardTherapyOverview);
}

export default dashboardTherapyOverviewSaga;
